module.exports = __webpack_public_path__ + "img/apidays-2021-snapshot-4.796b1945.jpg";